import { atom } from 'recoil';

export const searchTerm = atom<string>({
  key: 'searchTerm',
  default: '',
});
